import React from "react"
import {Button, Tabs} from "antd"
import {LogOut} from "lucide-react"
import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"

// Cadre commun de l'espace connecté : en-tête (logo org + email + déconnexion)
// et onglets Dashboard / Profil / Famille. `hideTabs` pour l'écran "en attente".
// `allowFamily=false` (config org) → l'onglet "Ma famille" est masqué.
// Header responsive : logo+titre à gauche (tronqué si besoin), bouton à droite
// (texte sur desktop, icône seule sur mobile via la classe acs-logout-label).
export default function AccountShell({org, account, onLogout, tab, onTab, children, hideTabs, allowFamily = true}) {
    const tabItems = [
        {key: "dashboard", label: t`Tableau de bord`},
        {key: "profile", label: t`Mon profil`},
    ]
    if (allowFamily) {
        tabItems.push({key: "family", label: t`Ma famille`})
    }
    return (
        <div>
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                gap: 10, marginBottom: 18,
            }}>
                <div style={{display: "flex", alignItems: "center", gap: 12, minWidth: 0}}>
                    {org?.logo && (
                        <img
                            src={org.logo}
                            alt={org?.name || ""}
                            style={{height: 40, width: "auto", maxWidth: 56, objectFit: "contain", flexShrink: 0}}
                        />
                    )}
                    <div style={{minWidth: 0}}>
                        <div style={{fontWeight: 700, fontSize: 17, lineHeight: 1.2}}>
                            <Trans>Mon espace</Trans>
                        </div>
                        {account?.email && (
                            <div style={{
                                color: "#a8a195", fontSize: 12.5,
                                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                                maxWidth: "60vw",
                            }}>{account.email}</div>
                        )}
                    </div>
                </div>
                <Button
                    onClick={onLogout}
                    aria-label={t`Se déconnecter`}
                    icon={<LogOut size={16}/>}
                    style={{flexShrink: 0}}
                >
                    <span className="acs-logout-label"><Trans>Se déconnecter</Trans></span>
                </Button>
            </div>

            {!hideTabs && (
                <Tabs
                    activeKey={tab}
                    onChange={onTab}
                    items={tabItems}
                />
            )}

            <div style={{marginTop: 8}}>
                {children}
            </div>
        </div>
    )
}
